import React, {useEffect} from "react";
import {AEInput, CardBody, CardFooter, CardHeader} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {AESVG} from "../../../../../_emywork/components/svg";
import {useIntl} from "react-intl";
import {useFormik} from "formik";
import * as teamMessagesActions from "../../_redux/teamMessages/actions";
import {AEMetadata} from "../../../../../_emywork/AEPagination";
import {Dropdown} from "react-bootstrap";
import {DropdownCustomToggler} from "../../../../../_metronic/_partials/dropdowns";
import {AEAvatar} from "../../../../../_emywork/components/AEAvatar";
import {CONTEXT} from "../../../Users/helpers/ModuleHelpers";
import {AELink} from "../../../../../_emywork/components/AELink";
import {AEDuration} from "../../../../../_emywork/components/moment";
import moment from "moment";
import KTAppChat from "../../../../../_metronic/_assets/js/components/chat";
import {AEButton} from "../../../../../_emywork/components/buttons";
import * as actions from "../../../Teams/_redux/actions";
import {HTTP_CREATED} from "../../../../../_emywork/helpers/AxiosHelpers";
import {useModuleContext} from "../../ModuleContext";
import {actionTypes} from "../../_redux/slice";

export function Content({id, onUpdate}) {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const {openDeleteDialog, openEditPage} = useModuleContext();
  const { authUser } = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );


  const { entity } = useSelector(
    state => {
      return state.teams[actionTypes.Details]
    }
    , shallowEqual )

  const formik = useFormik({
    initialValues: {
      message:''
    },
    onSubmit: (values)=>{
      dispatch(teamMessagesActions.createEntity({
        ...values,
        team_id: id,
        user_id: authUser.id
      })).then((r) => {
        if(r.status === HTTP_CREATED) {
          refresh();
          if(onUpdate) onUpdate();
          formik.resetForm()
        }

      });

    }
  });

  const refresh = () =>{
    dispatch(actions.fetchEntity(
      id,
      new AEMetadata({},{},{},['id', 'name', 'user_id', 'created_by', 'messages','messages.*.created_by','members']),
      actionTypes.Details
    )).then(r=>{
      KTAppChat.init();
    });
  }

  useEffect(() => {
    if(id) {
      refresh()
    }
  }, [dispatch, id]);


  const limit = 5;
  const getMembers = () => {
    let all_members = [...entity.members];
    if(entity.created_by && entity.members.findIndex(member=>member.id === entity.created_by.id) === -1) {
      all_members.push(entity.created_by)
    }

    return all_members;

  }

  return (
    <div className="card card-custom card-stretch">
      <CardHeader className="align-items-center align-items-between px-4 py-3">
        <div className="mr-auto font-weight-bolder font-size-lg">
          {entity.name}
        </div>
        <div className="">
          <div className="symbol-group symbol-hover justify-content-center">
            {
              getMembers().slice(0, limit).map(member=>(
                <AEAvatar key={member.id} entity={member} size={'35'}/>
              ))
            }
            {
              getMembers().length > limit &&
              <div className="symbol symbol-35 symbol-circle symbol-light-primary">
                <span className="symbol-label font-weight-bold">{getMembers().length-limit}+</span>
              </div>
            }

          </div>
        </div>
        {
          entity.user_id === authUser.id &&
          <div className="">
            <Dropdown>
              <Dropdown.Toggle as={DropdownCustomToggler} >
                <AESVG size={'lg'} path={'/General/Settings-1.svg'} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                <Dropdown.Item
                  onClick={() => {
                    openEditPage(id)
                  }}
                >
                  {formatMessage({id: 'EDIT'})}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    openDeleteDialog(id)
                  }}
                >
                  {formatMessage({id: 'DELETE'})}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>
        }

      </CardHeader>
      <CardBody>
        <div className="scroll scroll-pull">
          <div className="messages">
            {
              entity.messages.map(message=>{
                const isSameUser = authUser.id === message.user_id;

                return (
                  <div key={message.id} className={`d-flex flex-column mb-5 align-items-${isSameUser ? 'end' : 'start'}`}>
                    <div className="d-flex align-items-center">
                      <div className={`order-${isSameUser ? '3' : '1'}`}>
                        <AEAvatar entity={message.created_by} />
                      </div>

                      <AELink
                        to={`/${CONTEXT}/${message.created_by.username}`}
                        className="text-dark-75 text-hover-primary font-weight-bold font-size-h6 order-2 mx-2"
                      >
                        {
                          message.user_id === authUser.id ?
                            formatMessage({id:'YOU'}) :
                            `@`+message.created_by.username
                        }

                      </AELink>
                      <span className={`text-muted font-size-sm order-${isSameUser ? '1' : '3'}`}>
                        <AEDuration
                          duration={-moment().diff(moment(message.created_at), 'seconds')}
                          unit={'seconds'}
                          argWithSuffix
                        />
                      </span>
                    </div>
                    <div className={`mt-2 rounded p-5 bg-light-${isSameUser ? 'primary' : 'secondary'} text-dark-50 font-weight-bold font-size-lg text-left max-w-400px`}>
                      {message.message}
                    </div>
                  </div>
                )
              })
            }

          </div>
        </div>
      </CardBody>
      <CardFooter className="card-footer align-items-center">
        <AEInput
          type={'textarea'}
          borderless
          validation={false}
          withFeedbackLabel={false}
          className={"form-control-solid"}
          field={formik.getFieldProps('message')}
          form={formik}
          name={"message"}
          label={"MESSAGE"}
          rows={3}
        />
        <AEButton
          className={'text-uppercase mt-5'}
          fontWeight={'bold'}
          // block
          onClick={formik.handleSubmit}
        >
          {formatMessage({id: 'SEND'})}
        </AEButton>
      </CardFooter>
    </div>
  );


}
